import React, { useEffect } from 'react';
import Footer from './common/home/Footer';
import TopBar from './common/home/TopBar';
import { List, ListItem, ListItemText, ListSubheader, Typography } from '@mui/material';
import { homeBackground } from './common/ColorCodes';
import { CONST_BUSINESS_NAME, CONST_BUSINESS_MAIL, CONST_SITE_LABEL } from './common/Helper';

export const PrivacyPolicy = () => {

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | Privacy Policy`
  }, [])

  return (
    <div style={{ backgroundColor: homeBackground }}>
      <TopBar />

      <div className='policy-container'>
        <Typography variant={'h5'}>Privacy Policy for {CONST_SITE_LABEL}</Typography>

        <List>
          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">1. Introduction</ListSubheader>
            <ListItemText className='list-item-text'>Welcome to {CONST_SITE_LABEL} ({CONST_BUSINESS_NAME})! This Privacy Policy describes how we collect, use, and disclose
              information when you use our web application and services.</ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">2. Information We Collect</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    2.1 <span className='item-bold'>Personal Information:</span> We may collect personal information from you when you register for
                    an account, such as your name, email address, and contact details.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    2.2 <span className='item-bold'>Account Data:</span> We may collect data related to your AWS account, including account
                    identifiers, usage data, and configuration details, in order to provide our AWS account
                    recommendations and cost optimization services.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    2.3 <span className='item-bold'>Log Data:</span> Like many websites and applications, we automatically collect certain information
                    when you access or use {CONST_SITE_LABEL}. This may include your IP address, browser type,
                    operating system, referral URLs, and other usage data.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">3. Use of Information</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    3.1 We use the information we collect to provide and improve {CONST_SITE_LABEL}, including
                    generating AWS account recommendations, optimizing costs, and enhancing user experience.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    3.2. We may also use your information to communicate with you, respond to your inquiries, and
                    send you important updates and announcements related to our services.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">4. Data Sharing and Disclosure</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    4.1 We may share your information with third-party service providers who assist us in operating
                    our application, conducting business activities, or servicing you, provided that such parties
                    agree to keep this information confidential.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    4.2. We may also disclose your information if required by law or in response to a valid legal
                    request, such as a court order or government investigation.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">5. Data Security</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    5.1 We take reasonable measures to protect your information from unauthorized access,
                    alteration, disclosure, or destruction. However, please be aware that no method of transmission
                    over the internet or electronic storage is 100% secure.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    5.2. We encourage you to take appropriate measures to protect your personal information, such
                    as choosing a strong password and keeping your account credentials confidential.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">6. Your Rights</ListSubheader>
            <ListItemText className='list-item-text'>
              <List className='sublist'>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    6.1 You have the right to access, update, or delete your personal information. You may also
                    have the right to restrict or object to certain processing activities.
                  </ListItemText>
                </ListItem>
                <ListItem className='list-item sublist-item'>
                  <ListItemText className='list-item-text'>
                    6.2. If you wish to exercise any of these rights, please contact us using the information provided
                    in Section 9.
                  </ListItemText>
                </ListItem>
              </List>
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">7. Children's Privacy</ListSubheader>
            <ListItemText className='list-item-text'>
              {CONST_SITE_LABEL} is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you believe we have inadvertently collected such information, please contact us immediately.
            </ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">8. Changes to this Privacy Policy</ListSubheader>
            <ListItemText className='list-item-text'>We reserve the right to update or change this Privacy Policy at any time. Any changes will be
              effective immediately upon posting the updated Privacy Policy on our website.</ListItemText>
          </ListItem>

          <ListItem className='list-item'>
            <ListSubheader className='list-tem-heading item-bold' variant="h5">9. Contact Us</ListSubheader>
            <ListItemText className='list-item-text'>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at <span className='item-bold'>{CONST_BUSINESS_MAIL}</span></ListItemText>
          </ListItem>

        </List>
      </div>

      <Footer />
    </div>
  )
}
